import axios from 'axios'
import { writeExcel } from './excel'

export async function downloadStripeAudit() {
    const audit_data = await axios.get(`${process.env.REACT_APP_API_URL}/automation/audit-stripe`)
    console.log(audit_data)
    await writeExcel(audit_data.data, 'Stripe CTP Audit')
}